import { StyledNotification } from 'components/shared/Notification.styled';
import { Heading1 } from 'components/shared/Typography';
import styled from 'styled-components';
import { container, screen, spacing } from 'theme';

export const StyledJobOfferListComponent = styled.div`
  margin: 0 auto;
  max-width: ${container('xlMax')};
  width: 100%;
  padding: ${spacing('xl2')} ${spacing('md')};
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing('lg')};

  @media (min-width: ${screen('lg')}) {
    grid-template-columns: 288px 1fr;
    gap: ${spacing('md')} ${spacing('xl')};
    padding-top: ${spacing('xl4')};
  }
`;

export const StyledJobOfferListTitle = styled(Heading1)`
  && {
    text-align: center;
    user-select: none;

    @media (min-width: ${screen('lg')}) {
      text-align: left;
      grid-column: 2;
      grid-row: 1;

      &::before {
        left: 0;
        transform: unset;
      }
    }
  }
`;

export const StyledFilterSort = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-between;

  @media (min-width: ${screen('lg')}) {
    grid-column: 1;
    display: none;
  }
`;

export const StyledSort = styled.div`
  min-width: 14rem;
`;

export const StyledFiltersContainer = styled.div`
  @media (min-width: ${screen('lg')}) {
    grid-column: 1;
    grid-row: 1;
  }
`;

export const StyledFiltersGrid = styled.div`
  position: relative;
  @media (min-width: ${screen('lg')}) {
    grid-column: 2;
    grid-row: 1 / span 3;
    padding-top: ${spacing('xl5')};
  }

  ${StyledNotification} {
    margin-bottom: ${spacing('lg')};
  }
`;
